import React, { Component } from "react";
import BrandIcon from "../Icon/BrandIcon";
import FooterIcon from "../Icon/FooterIcon";

export default class FooterFrontend extends Component {
  render() {
    return (
      <footer className="h-100 w-100">
        <div className="container mx-auto position-relative p-0">
          <div className="row">
            <div className="item-footer col-lg-4 col-md-6 me-5">
              <FooterIcon />
              <p className="tagline mt-3">
                Website untuk belajar design dan code dari mentor yang sangat
                berpengalaman di bidangnya masing-masing.
              </p>
              <p className="tagline mt-2">
                Copyright © 2021 All rights reserved by TamanDev
              </p>
            </div>
            <div className="col-lg-2 col-md-6">
              <h2 className="footer-text-title">Product</h2>
              <nav className="list-unstyled">
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Real Time Analytic
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Easy to Operate
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Full Secured
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Analytic Tool
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Story
                  </a>
                </li>
              </nav>
            </div>
            <div className="col-lg-2 col-md-6">
              <h2 className="footer-text-title">Company</h2>
              <nav className="list-unstyled">
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Contact Us
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Blog
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Culture
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Security
                  </a>
                </li>
              </nav>
            </div>
            <div className="col-lg-2 col-md-6">
              <h2 className="footer-text-title">Support</h2>
              <nav className="list-unstyled">
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Getting Started
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Help Center
                  </a>
                </li>
                <li className="list-space">
                  <a href="#" className="list-menu">
                    Server Status
                  </a>
                </li>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
